import React, { useEffect } from 'react'
import DatePicker from '../../LaridaeApp/datepicker/container/DatePicker'
import { connect } from 'react-redux'
import ExistenciaDiariaPorVariedad from '../components/ExistenciaDiariaPorVariedad'
import ExistenciaDiariaPorCereal from '../components/ExistenciaDiariaPorCereal'
import ComposicionStockExportadores from '../components/ComposicionStockExportadores'
import {
  obtenerExistenciaDiariaPorVariedad,
  obtenerExistenciaDiariaPorCereal,
  obtenerComposicionStockExportadores
} from '../actions'

function ExistenciaDiaria (props) {
  const {
    obtenerExistenciaDiariaPorCereal,
    obtenerExistenciaDiariaPorVariedad,
    obtenerComposicionStockExportadores
  } = props

  useEffect(() => {
    obtenerExistenciaDiariaPorCereal(new Date())
    obtenerExistenciaDiariaPorVariedad(new Date())
    obtenerComposicionStockExportadores()
  }, [obtenerExistenciaDiariaPorCereal, obtenerExistenciaDiariaPorVariedad])

  const actualizarFecha = (fecha) => {
    obtenerExistenciaDiariaPorCereal(fecha)
    obtenerExistenciaDiariaPorVariedad(fecha)
  }

  return (
    <>
      <div className='container-entre-fechas' style={{ margin: '-3% auto 0 auto' }}>
        <DatePicker
          disabledFuture
          locale='es'
          onDateChange={actualizarFecha}
          titulo='Seleccione una fecha'
          value='fechas'
        />
      </div>
      <ExistenciaDiariaPorCereal />
      <ExistenciaDiariaPorVariedad />
      <ComposicionStockExportadores />
    </>
  )
}

const mapActionsToProps = {
  obtenerExistenciaDiariaPorCereal,
  obtenerExistenciaDiariaPorVariedad,
  obtenerComposicionStockExportadores
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(ExistenciaDiaria)
